<template>
  <div>
    <div class="mt-4">
      <b-link @click="handleGoBack">Back</b-link>
      <b-card
        :img-src="session.imgURL"
        img-alt="Card image"
        img-left
        class="mb-3"
        style="cursor: pointer"
        @click="handleSessionSelectionClick(session)"
      >
        <b-card-text style="color: black">
          <h4>{{ session.title }}</h4>
          <h6>{{ session.date }}</h6>
          <h6>{{ session.topic }}</h6>
          <p>{{ session.description }}</p>
        </b-card-text>
      </b-card>
      <Meeting v-if="false" />
    </div>
  </div>
</template>

<script>
import Meeting from "./meeting";
export default {
  name: "Display_Sessions_MySessions",
  components: {
    Meeting
  },
  props: {
    resource: {
      type: Object,
      required: () => {
        return {};
      }
    },
    settings: {
      type: Object,
      required: () => {
        return {};
      }
    },
    session: {
      type: Object,
      default: () => {
        return {};
      },
      required: true
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    handleSessionSelectionClick(session) {
      this.$emit("session-selected", session);
    },
    handleGoBack() {
      this.$emit("go-back");
    }
  },
  data() {
    return {
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      },
      clientId: "bf79d19b-b0de-41f4-878a-b89e69430cfa",
      uiConfig: {
        header: true
        // for more UI options, see here: https://docs.dyte.io/javascript/reference/dyte-ui-config/
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
